export default {
	searchParams: {
		comm: {
			lineCd: '',
			cdDesc: '',
			lineCdList: []
		}
	},
	factoryList: [],
	/**factory 필터되지 않은 전체 리스트 */
	lineList: [],
	/**factory 필터된 전체 리스트 */
	lineFilteredList: [] /**factory 필터된 전체 리스트 */,

	/**tab open 연동 테스트 데이터 */
	gqmsSeq: '',
	resultFileList: [],
	resultObj: {},
	isSaveFlag: false,
	saveDataObj2: {},
	saveDataObj3: {},
	saveDataObj4: {},
	saveDataObj5: {}
};
